"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvertInfoIconSvg = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Icon = styled_components_1.default.svg `
    color: ${({ theme }) => theme.colorTextNavRest || '#fff'};
`;
const InvertInfoIconSvg = () => (react_1.default.createElement(Icon, { viewBox: "0 0 32 32" },
    react_1.default.createElement("path", { fill: "currentColor", d: "M14.842,8.9q0-1.327,1.172-1.328a1.116,1.116,0,0,1,.874.342A1.428,1.428,0,0,1,17.2,8.9a1.4,1.4,0,0,1-.312.972,1.112,1.112,0,0,1-.869.347,1.187,1.187,0,0,1-.84-.308A1.327,1.327,0,0,1,14.842,8.9Z" }),
    react_1.default.createElement("circle", { fill: "none", cx: "16", cy: "16", r: "16" }),
    react_1.default.createElement("circle", { fill: "none", stroke: "currentColor", cx: "16", cy: "16", r: "15.5" }),
    react_1.default.createElement("rect", { fill: "currentColor", x: "15", y: "13", width: "2", height: "11" })));
exports.InvertInfoIconSvg = InvertInfoIconSvg;
//# sourceMappingURL=InvertInfoIconSvg.js.map